import React from "react";
import Outstanding from "../delivered/Outstanding";

function Delivereditems(props) { 
  const {orders} = props;
  return (
    <div className="heightscr- customscroll-">
      <div className="billitem_main billitem_main_delivered ">
        {orders && orders.length > 0 && orders.map((item, index) => (          
          <Outstanding 
          key={index}
          {...item} />
        ))}
      </div>
    </div>
    );
}

export default Delivereditems;
